/* HiShroom GemPages Theme - JavaScript */

(function() {
  'use strict';

  // Utilities
  const $ = (selector, context = document) => context.querySelector(selector);
  const $$ = (selector, context = document) => [...context.querySelectorAll(selector)];

  // Event System
  const HiShroom = {
    events: {},
    on(event, callback) {
      if (!this.events[event]) this.events[event] = [];
      this.events[event].push(callback);
    },
    emit(event, data) {
      if (this.events[event]) {
        this.events[event].forEach(cb => cb(data));
      }
    }
  };
  window.HiShroom = HiShroom;

  // Scroll Animations
  function initAnimations() {
    const elements = $$('[data-animate]');
    if (!elements.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const delay = entry.target.dataset.animateDelay || 0;
          setTimeout(() => {
            entry.target.classList.add('is-visible');
          }, delay * 100);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    elements.forEach(el => observer.observe(el));
  }

  // Animated Counters
  function initCounters() {
    const counters = $$('[data-counter]');
    if (!counters.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.8 });

    counters.forEach(el => observer.observe(el));
  }

  function animateCounter(el) {
    const target = parseFloat(el.dataset.counter);
    const duration = 1800;
    const start = performance.now();
    const isDecimal = target % 1 !== 0;

    function update(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = target * eased;

      if (isDecimal) {
        el.textContent = current.toFixed(1);
      } else {
        el.textContent = Math.floor(current);
      }

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        el.textContent = isDecimal ? target.toFixed(1) : target;
      }
    }

    requestAnimationFrame(update);
  }

  // Mobile Menu
  function initMobileMenu() {
    const toggle = $('.nav-mobile-toggle');
    const menu = $('.mobile-menu');
    const close = $('.mobile-menu-close');
    
    if (!toggle || !menu) return;

    toggle.addEventListener('click', () => {
      menu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });

    if (close) {
      close.addEventListener('click', () => {
        menu.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    }

    // Close on link click
    $$('.mobile-menu-links a', menu).forEach(link => {
      link.addEventListener('click', () => {
        menu.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }

  // FAQ Accordion
  function initFAQ() {
    const questions = $$('.faq-question');
    
    questions.forEach(question => {
      question.addEventListener('click', () => {
        const item = question.closest('.faq-item');
        const isOpen = item.classList.contains('is-open');
        
        // Close all others (optional - remove for multi-open)
        $$('.faq-item.is-open').forEach(open => {
          if (open !== item) open.classList.remove('is-open');
        });
        
        item.classList.toggle('is-open', !isOpen);
      });
    });
  }

  // Cart Drawer
  function initCartDrawer() {
    const drawer = $('.cart-drawer');
    const overlay = $('.cart-drawer-overlay');
    const openBtns = $$('[data-cart-open]');
    const closeBtn = $('.cart-drawer-close');

    if (!drawer) return;

    function openCart() {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeCart() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    openBtns.forEach(btn => btn.addEventListener('click', openCart));
    if (closeBtn) closeBtn.addEventListener('click', closeCart);
    if (overlay) overlay.addEventListener('click', closeCart);

    HiShroom.on('cart:open', openCart);
    HiShroom.on('cart:close', closeCart);
  }

  // Product Slider Navigation
  function initProductSlider() {
    const sliders = $$('.products-slider');
    
    sliders.forEach(slider => {
      const section = slider.closest('.products-section');
      if (!section) return;
      
      const prevBtn = section.querySelector('[data-slider-prev]');
      const nextBtn = section.querySelector('[data-slider-next]');
      
      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          slider.scrollBy({ left: -324, behavior: 'smooth' });
        });
      }
      
      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          slider.scrollBy({ left: 324, behavior: 'smooth' });
        });
      }
    });
  }

  // Add to Cart - Uses FormData to include all form inputs (including selling_plan from Seal Subscriptions)
  function initAddToCart() {
    // Find all product forms
    const forms = $$('form[action="/cart/add"], form.product-form');
    
    forms.forEach(form => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = form.querySelector('[type="submit"]');
        const originalText = btn.innerHTML;
        
        btn.disabled = true;
        btn.innerHTML = 'Adding...';
        
        try {
          // Use FormData to automatically include ALL form inputs
          // This ensures Seal Subscriptions' selling_plan input is included
          const formData = new FormData(form);
          
          // Debug: Log what's being sent
          console.log('Adding to cart (FormData):', {
            id: formData.get('id'),
            quantity: formData.get('quantity'),
            selling_plan: formData.get('selling_plan') || '(none)'
          });
          
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          });
          
          const data = await response.json();
          
          if (response.ok) {
            btn.innerHTML = 'Added! ✓';
            HiShroom.emit('cart:updated');
            
            // Update cart count and drawer
            await updateCartCount();
            await updateCartDrawer();
            HiShroom.emit('cart:open');
          } else {
            // Show specific error from Shopify
            console.error('Cart error:', data);
            btn.innerHTML = data.description || 'Error - Try again';
          }
        } catch (error) {
          btn.innerHTML = 'Error - Try again';
          console.error('Add to cart error:', error);
        }
        
        setTimeout(() => {
          btn.disabled = false;
          btn.innerHTML = originalText;
        }, 2500);
      });
    });
  }
  
  // Update Cart Drawer Contents
  async function updateCartDrawer() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      const itemsContainer = $('#cart-drawer-items');
      const subtotalEl = $('#cart-drawer-subtotal');
      const shippingText = $('#shipping-text');
      const shippingProgress = $('#shipping-progress');
      const FREE_SHIPPING_THRESHOLD = 5000; // €50 in cents
      
      // Update shipping banner
      if (shippingText) {
        if (cart.total_price >= FREE_SHIPPING_THRESHOLD) {
          shippingText.innerHTML = '🎉 You qualify for <span>FREE SHIPPING!</span>';
        } else if (cart.total_price > 0) {
          const remaining = (FREE_SHIPPING_THRESHOLD - cart.total_price) / 100;
          shippingText.innerHTML = 'Spend <span>€' + remaining.toFixed(2).replace('.', ',') + '</span> more for <span>FREE SHIPPING</span> 🚚';
        } else {
          shippingText.innerHTML = 'Spend <span>€50,00</span> for <span>FREE SHIPPING</span> 🚚';
        }
      }
      
      if (shippingProgress) {
        const progress = Math.min((cart.total_price / FREE_SHIPPING_THRESHOLD) * 100, 100);
        shippingProgress.style.width = progress + '%';
      }
      
      if (!itemsContainer) return;
      
      if (cart.item_count === 0) {
        itemsContainer.innerHTML = `
          <div class="cart-drawer-empty">
            <p style="font-size: 48px; margin-bottom: 16px;">🍄</p>
            <p style="font-weight: 600; color: #333;">Your cart is empty</p>
            <p style="font-size: 13px; color: #888;">Add some mushroom magic!</p>
            <a href="/collections/all" class="btn btn-pink" style="margin-top: 24px; display: inline-block; padding: 12px 24px; border-radius: 8px; background: #FF1493; color: #fff; text-decoration: none;">Shop Now</a>
          </div>
        `;
      } else {
        let itemsHTML = '';
        cart.items.forEach(item => {
          const imgUrl = item.image ? (typeof item.image === 'string' ? item.image : item.image) : '';
          const productUrl = item.url || `/products/${item.handle}`;
          
          // Check if this is a subscription item
          const isSubscription = item.selling_plan_allocation ? true : false;
          const subscriptionName = isSubscription ? item.selling_plan_allocation.selling_plan.name : '';
          
          itemsHTML += `
            <div class="cart-drawer-item" data-key="${item.key}">
              <a href="${productUrl}" class="cart-item-img-link">
                <img src="${imgUrl}" alt="${item.title}" class="cart-item-img">
              </a>
              <div class="cart-item-details">
                <div class="cart-item-top">
                  <a href="${productUrl}" class="cart-item-title-link">${item.product_title}</a>
                  <div class="cart-item-prices">
                    <span class="cart-item-price">${formatMoney(item.final_price)}</span>
                  </div>
                </div>
                ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-item-variant">${item.variant_title}</p>` : ''}
                ${isSubscription ? `<p class="cart-item-subscription" style="font-size: 11px; color: #FF1493; font-weight: 600; margin-top: 4px;">🔄 ${subscriptionName}</p>` : ''}
                <div class="cart-item-actions">
                  <div class="cart-item-qty">
                    <button type="button" class="cart-qty-btn" data-change="-1" data-key="${item.key}">−</button>
                    <span>${item.quantity}</span>
                    <button type="button" class="cart-qty-btn" data-change="1" data-key="${item.key}">+</button>
                  </div>
                  <button type="button" class="cart-item-remove" data-key="${item.key}" aria-label="Remove">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          `;
        });
        itemsContainer.innerHTML = itemsHTML;
        
        // Add event listeners for quantity changes and remove
        initCartItemActions();
      }
      
      if (subtotalEl) {
        subtotalEl.textContent = formatMoney(cart.total_price);
      }
      
      // Update cart count badge in drawer
      const countEl = $('.cart-drawer-count');
      if (countEl) {
        countEl.textContent = cart.item_count;
        countEl.style.display = cart.item_count > 0 ? 'inline' : 'none';
      }
    } catch (error) {
      console.error('Error updating cart drawer:', error);
    }
  }
  
  // Cart Item Actions (quantity change, remove)
  function initCartItemActions() {
    // Quantity buttons
    $$('.cart-qty-btn').forEach(btn => {
      btn.addEventListener('click', async () => {
        const key = btn.dataset.key;
        const change = parseInt(btn.dataset.change);
        const qtySpan = btn.parentElement.querySelector('span');
        const currentQty = parseInt(qtySpan.textContent);
        const newQty = Math.max(0, currentQty + change);
        
        await updateCartItem(key, newQty);
      });
    });
    
    // Remove buttons
    $$('.cart-item-remove').forEach(btn => {
      btn.addEventListener('click', async () => {
        const key = btn.dataset.key;
        await updateCartItem(key, 0);
      });
    });
  }
  
  // Update Cart Item Quantity
  async function updateCartItem(key, quantity) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: key, quantity })
      });
      
      await updateCartCount();
      await updateCartDrawer();
    } catch (error) {
      console.error('Error updating cart item:', error);
    }
  }
  
  // Format money helper
  function formatMoney(cents) {
    return new Intl.NumberFormat('en-IE', {
      style: 'currency',
      currency: Shopify.currency?.active || 'EUR'
    }).format(cents / 100);
  }

  // Update Cart Count
  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const countEls = $$('.nav-cart-count');
      
      countEls.forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }

  // Sticky Header Shadow
  function initStickyHeader() {
    const nav = $('.nav');
    if (!nav) return;

    let lastScroll = 0;
    
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      
      if (currentScroll > 100) {
        nav.style.boxShadow = '0 2px 20px rgba(0,0,0,0.1)';
      } else {
        nav.style.boxShadow = 'none';
      }
      
      lastScroll = currentScroll;
    }, { passive: true });
  }

  // Newsletter Form
  function initNewsletter() {
    const forms = $$('.newsletter-form');
    
    forms.forEach(form => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const input = form.querySelector('input[type="email"]');
        const btn = form.querySelector('button');
        const originalText = btn.textContent;
        
        if (!input.value) return;
        
        btn.disabled = true;
        btn.textContent = 'Subscribing...';
        
        // Simulate API call (replace with actual endpoint)
        setTimeout(() => {
          btn.textContent = 'Subscribed!';
          input.value = '';
          
          setTimeout(() => {
            btn.disabled = false;
            btn.textContent = originalText;
          }, 3000);
        }, 1000);
      });
    });
  }

  // Smooth Scroll for Anchor Links
  function initSmoothScroll() {
    $$('a[href^="#"]').forEach(link => {
      link.addEventListener('click', (e) => {
        const href = link.getAttribute('href');
        if (href === '#') return;
        
        const target = $(href);
        if (target) {
          e.preventDefault();
          const offset = 80; // Account for sticky header
          const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      });
    });
  }

  // Initialize Everything
  function init() {
    initAnimations();
    initCounters();
    initMobileMenu();
    initFAQ();
    initCartDrawer();
    initProductSlider();
    initAddToCart();
    initStickyHeader();
    initNewsletter();
    initSmoothScroll();
    updateCartCount();
  }

  // Run on DOM Ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify Theme Editor - Live Preview Support
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      init();
    });
    
    document.addEventListener('shopify:section:reorder', function(event) {
      init();
    });
    
    document.addEventListener('shopify:block:select', function(event) {
      // Scroll to selected block
      const block = event.target;
      if (block) {
        block.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

})();
